import { object, string } from "yup";
import { useCommonComponentContext } from "@maysoft/common-component-react";

import Helpers from "../../../commons/helpers";
import Strings from "../../../constants/strings";
import CommunityService from "../../../services/message/Community.service";

import { ICommunityError } from "./useData";
import { multiLangSchema } from "../../../commons/yup";
import { Constants } from "../../../constants/constants";
import { ICommunity } from "../../../commons/interfaces";
import { AvailableLanguage, Mode } from "../../../constants/enums";

const schemaObject = object({
    name: string().required(),
    description: multiLangSchema([AvailableLanguage.Vietnamese]),
    avatarImage: string().required(),
    coverImage: string().required(),
});

const REQUIRED_MULTI_LANG_KEY = ["description"];

const useSubmit = ({
    data,
    mode,
    onChangeMode,
    setError,
    onGoBack,
    setLanguage,
}: {
    mode: Mode;
    data: ICommunity;
    onGoBack: () => void;
    onChangeMode: (mode: Mode) => void;
    setLanguage: React.Dispatch<React.SetStateAction<string>>;
    setError: React.Dispatch<React.SetStateAction<ICommunityError>>;
}) => {
    const {
        clientId,
        tenantCode,
        serviceCode,
        organizationId,
        onError = () => { },
        onSuccess = () => { },
        onShowLoading = () => { },
        onHideLoading = () => { },
    } = useCommonComponentContext();

    const onSubmit = async () => {
        if (mode === Mode.View) return onChangeMode(Mode.Update);

        try {
            onShowLoading();
            await schemaObject.validate(data, { abortEarly: false });
            const requestData = {
                clientId,
                serviceCode,
                tenantCode,
                avatarImageUrl: Helpers.getFileAccessUrl(data?.avatarImage),
                coverImageUrl: Helpers.getFileAccessUrl(data?.coverImage),
                organizationId: organizationId || "0",
                setting: JSON.stringify(data.setting),
                type: data?.type,
                name: data?.name,
                coverImage: data?.coverImage,
                avatarImage: data?.avatarImage,
                description: data?.description,
                metaHeader: data?.metaHeader,
                updateTime: data?.updateTime,
                id: data?.id,
            };

            if (!Helpers.isNullOrEmpty(requestData?.id)) {
                await CommunityService.update(requestData);
                onSuccess(Strings.TOPIC.UPDATE_SUCCESS);
            } else {
                await CommunityService.create(requestData);
                onSuccess(Strings.TOPIC.CREATE_SUCCESS);
            }
            onGoBack();
        } catch (error: any) {
            if (error.name === "ValidationError") {
                const validationError = Helpers.handleValidationError(error) as ICommunityError;
                setError(validationError);
                for (const [key, _] of Object.entries(validationError)) {
                    if (REQUIRED_MULTI_LANG_KEY.includes(key)) setLanguage(Constants.DefaultLanguage);
                }
                return;
            }
            const e = Helpers.renderExceptionError(error);
            onError(e);
        } finally {
            onHideLoading();
        }
    };
    return { onSubmit };
};

export default useSubmit;
